import { Injectable } from '@angular/core';
import { API } from "../constants";
import { AppService } from 'src/app/core/services/app.service';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  constructor(private appService: AppService) {}

  isActiveFeature(featuresList: any[], feature: string): boolean {
    if (!featuresList?.length) {
      return false;
    }
    return featuresList?.some((item: any) => item.featureKeyName === feature);
  }

  async loadOrganizationFeatures(orgId: string | number): Promise<any[]> {
    try {
      if (!orgId) {
        return [];
      }
      const url = `admin/v1/${API.GET_ORGANIZATION_FEATURES}/${orgId}`;
      const response = await this.appService.getBaseRequest(url).toPromise();
      if (response && response.status === 0) {
        // Return array of feature IDs that are active for this organization
        return (response.result || []).filter(
          (item: any) => item.dataStatus === "A"
        );
      } else {
        throw new Error(
          response?.message || "Failed to load organization features"
        );
      }
    } catch (error) {
      console.error("Error loading organization features:", error);
      return [];
    }
  }

  async loadAllOrganizationFeatures(): Promise<any[]> {
    try {
      const url = `admin/v1/${API.GET_ALL_ORGANIZATION_FEATURES}`;
      const response = await this.appService.getBaseRequest(url).toPromise();
      if (response && response.status === 0) {
        // Return array of feature IDs that are active for this organization
        return (response.result || []).filter(
          (item: any) => item.dataStatus === "A"
        );
      } else {
        throw new Error(
          response?.message || "Failed to load organization features"
        );
      }
    } catch (error) {
      console.error("Error loading organization features:", error);
      return [];
    }
  }

  async loadAllOrganizationFeaturesByFeature(featureKeyName: string): Promise<any[]> {
    try {
      const url = `admin/v1/${API.GET_ALL_ORGANIZATION_FEATURES_BY_FEATURE_KEY_NAME}?featureKeyName=${featureKeyName}`;
      const response = await this.appService.getBaseRequest(url).toPromise();
      if (response && response.status === 0) {
        // Return array of feature IDs that are active for this organization
        return (response.result || []).filter(
          (item: any) => item.dataStatus === "A"
        );
      } else {
        throw new Error(
          response?.message || "Failed to load organization features"
        );
      }
    } catch (error) {
      console.error("Error loading organization features:", error);
      return [];
    }
  }

  createPubnubUser(user: any) {
    if (user) {
      let URL = API.CREATE_PUBNUB_USER;
      this.appService.postBaseRequest(URL, user).subscribe(async (res) => {
        let data = res?.data;
        console.log("data", res?.data);
        return data;
      });
    }
  }

  createPubnubChannel(channel: any) {
    if (channel) {
      let URL = API.CREATE_PUBNUB_CHANNEL;
      this.appService.postBaseRequest(URL, channel).subscribe(async (res) => {
        let data = res?.data;
        console.log("data", res?.data);
        return data;
      });
    }
  }
}